import { v4 as uuid } from 'uuid'

import delay from '../../utils/delay'

import {
  IFilesService,
  GetFileUrl,
  UploadFile,
  GetFileInfo,
  GetFileDownloadUrl,
  DeleteFile,
  GetExcelForCreativeId,
  GetDownloadFormatsetZipUrl,
} from '../../interfaces/services/files'
import { resultSuccess } from '../../interfaces/base'

import owl from '../../assets/images/owl.jpg'

export const filesServiceMock: (DI: any) => IFilesService = (DI) => {
  const getFile = async (url: string) => {
    return url
  }

  const getFileInfo: GetFileInfo = async (id) => {
    await delay(1000)

    return resultSuccess({
      id: uuid(),
      url: owl,
      meta: {},
    })
  }

  const uploadFile: UploadFile = async (_file, _creativeId) => {
    await delay(1000)

    return resultSuccess({
      id: uuid(),
      url: owl,
      meta: {},
    })
  }

  const getFileUrl: GetFileUrl = (fileId) => {
    return `${fileId}`
  }

  const getFileThumbnailUrl: GetFileUrl = (fileId) => {
    return `${fileId}`
  }

  const getFileDownloadUrl: GetFileDownloadUrl = (
    fileId,
    creativeId,
    slideOrder,
  ) => {
    if (slideOrder) {
      return `${fileId} ${creativeId} ${slideOrder}`
    } else {
      return `${fileId} ${creativeId}`
    }
  }
  const getExcel: GetExcelForCreativeId = (creativeId) => {
    return `${creativeId}`
  }

  const deleteFile: DeleteFile = async (id) => {
    return true
  }

  const getDownloadFormatsetZipUrl: GetDownloadFormatsetZipUrl = (
    formatsetId,
  ) => {
    return `${formatsetId}`
  }

  return {
    getFileUrl,
    getFileThumbnailUrl,
    getFileDownloadUrl,

    getExcel,
    getFile,
    getFileInfo,

    uploadFile,

    deleteFile,
    getDownloadFormatsetZipUrl,
  }
}

export default filesServiceMock
